import type {ComputationResult} from './../computation-result';
import type {Computation} from './../computation';
import type {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.MaxTime
 */
export interface MaxTime extends Computation._UnivariateComputation {
    // PolyJson type
    type: 'max_time';
}

export namespace MaxTime {
    export const type = 'max_time';
}

/** @deprecated Use Computation.isMaxTime() */ export function isMaxTime(toTest: Computation): toTest is MaxTime { return MaxTime.type === toTest['type']; }

export namespace MaxTime {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.MaxTime$MaxTimeResult
     */
    export interface MaxTimeResult extends _AvailableResult {
        timestamp: string;

        // PolyJson type
        type: 'max_time';
    }

    export namespace MaxTimeResult {
        export const type = 'max_time';
    }

    /** @deprecated Use ComputationResult.isMaxTimeResult() */ export function isMaxTimeResult(toTest: ComputationResult): toTest is MaxTimeResult { return MaxTimeResult.type === toTest['type']; }
}